import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { useStorageSelectors } from "../../../../../../../app/state/storageObjectSlice/hook/use-storage-selectors";
import { AssistantTools } from "./AssistantTools";
import { useUpdateStorageValue } from "../../../../../../../app/state/storageObjectSlice/hook/use-update-storage-value";
import { setAssistantValue } from "../../../../../redux/slice";
import { TDirection } from "../../../../../types";
import { useAssistantTool } from "../../../../../hooks/use-assistant-tool";
import { SkillsTool } from "./SkillsTool";
import { TSkills } from "../../../../../../../services/api/instances/skillsApi/types";
import styles from "./styles.module.css";

interface Props {
  direction: TDirection;
  skills: TSkills;
}

export const ModalBody = ({ direction, skills }: Props) => {
  const { objects } = useStorageSelectors("assistants");
  const { saveValue } = useUpdateStorageValue("assistants", setAssistantValue);
  const {
    meta,
    handleDeleteSkill,
    onSelectSkill,
    onSelectAssistant,
    handleChangeInstruction,
    handleRemoveAssistant,
  } = useAssistantTool(saveValue);
  const isAgentFirst = direction === "left" || direction === "top";
  const { t } = useTranslation();

  const agentBlock = (
    <div className={styles["agent-container"]}>
      <div className={styles["agent-badge"]}>{t("agents.agent")}</div>
    </div>
  );

  const toolsBlock = (
    <div
      className={classNames(
        styles["tools-container"],
        styles[`tools-layout-${direction}`],
      )}
    >
      {meta?.tools &&
        meta?.tools?.assistants &&
        meta?.tools?.assistants?.length > 0 &&
        meta.tools.assistants.map((tool) => {
          const assistant =
            objects.find((assist) => assist.ref === tool.ref) ?? null;
          return (
            <>
              <AssistantTools
                key={tool.id}
                assistantTool={tool}
                assistants={objects}
                allTools={meta?.tools?.assistants ?? []}
                assistant={assistant}
                onSelectAssistant={onSelectAssistant}
                onDeleteAssistantTool={handleRemoveAssistant}
                direction={direction}
                handleChangeInstruction={(e) =>
                  handleChangeInstruction(e, tool.id)
                }
              />
            </>
          );
        })}
      {meta?.tools &&
        meta?.tools?.skills &&
        meta?.tools?.skills?.length > 0 &&
        meta.tools.skills.map((skill) => (
          <SkillsTool
            key={skill.id}
            skills={skills}
            addSkills={meta.tools?.skills ?? []}
            skill={skill}
            onSelectSkill={onSelectSkill}
            onDeleteSkill={handleDeleteSkill}
          />
        ))}
    </div>
  );

  return (
    <div className={classNames(styles.workflow, styles[`layout-${direction}`])}>
      {isAgentFirst ? (
        <>
          {agentBlock}
          {toolsBlock}
        </>
      ) : (
        <>
          {toolsBlock}
          {agentBlock}
        </>
      )}
    </div>
  );
};
